import type { OperatingCostCategory, OperatingCostTotals } from '@/types/api'
import {
  displayOperatingCostCategoryName,
  formatCategoryTotal,
  formatOperatingCostAmount,
  formatOperatingCostRate,
} from '../lib/operating-costs'
import styles from '../CustosOperacionaisPage.module.css'

type OperatingCostTotalsTableProps = {
  categories: OperatingCostCategory[]
  totals: OperatingCostTotals
}

export function OperatingCostTotalsTable({
  categories,
  totals,
}: OperatingCostTotalsTableProps) {
  return (
    <section className={styles.totalsCard} aria-labelledby="operating-cost-totals-title">
      <h2 id="operating-cost-totals-title" className={styles.sectionTitle}>
        Totais por categoria
      </h2>
      <p className={styles.entryFormHint}>
        Total cadastrado de todos os meses, incluindo competências futuras e custos sem
        competência. No dashboard gerencial, as despesas entram no mês correspondente.
      </p>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th scope="col">Categoria</th>
              <th scope="col">Tipo</th>
              <th scope="col" className={styles.numeric}>
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {categories.map((category) => (
              <tr key={category.id}>
                <th scope="row">{displayOperatingCostCategoryName(category)}</th>
                <td>{category.kind === 'fixed' ? 'Fixo' : 'Variável'}</td>
                <td className={styles.numeric}>{formatCategoryTotal(category)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th scope="row" colSpan={2}>
                Total custos fixos
              </th>
              <td className={styles.numeric}>
                {formatOperatingCostAmount(totals.fixed_amount)}
              </td>
            </tr>
            <tr>
              <th scope="row" colSpan={2}>
                Total custos variáveis
              </th>
              <td className={styles.numeric}>
                {formatOperatingCostAmount(totals.variable_amount)}
              </td>
            </tr>
            <tr>
              <th scope="row" colSpan={2}>
                Total percentuais
              </th>
              <td className={styles.numeric}>
                {formatOperatingCostRate(totals.variable_percent)}
              </td>
            </tr>
            <tr>
              <th scope="row" colSpan={2}>
                Total em reais
              </th>
              <td className={styles.numeric}>
                {formatOperatingCostAmount(totals.amount)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
  )
}
